export const routes = {
  // KTP
  passport: '/',
  home: '/home',
  customerRefund: '/refund',
  refundResult: '/refund-result',
  refundInfo: '/refund-info',
  refundInfoLeaflet: '/refund-info-leaflet',
  faq: '/faq',
  faqEmail: '/faq-email',
  receipt: '/receipt',
  departureDate: '/departure-date',
  inquiryFaq: '/inquiry/faq',
  inquiryPassport: '/inquiry/passport',
  inquiryEmail: '/inquiry/email',
  inquiryQna: '/inquiry/qna',
};
